import { render, staticRenderFns } from "./organograma-right.vue?vue&type=template&id=05aa3cbb&"
import script from "./organograma-right.vue?vue&type=script&lang=js&"
export * from "./organograma-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05aa3cbb')) {
      api.createRecord('05aa3cbb', component.options)
    } else {
      api.reload('05aa3cbb', component.options)
    }
    module.hot.accept("./organograma-right.vue?vue&type=template&id=05aa3cbb&", function () {
      api.rerender('05aa3cbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/organograma-right.vue"
export default component.exports